import { Stack } from "@mui/material";

import { CreateCompanyReviewModal } from "components/CreateCompanyReviewModal";

import { CompanyPrivilegedReviews } from "./CompanyPrivilegedReviews";

import type { CompanyReviewProfile } from "types/company";

interface Props {
  companyId: number;
  error: string | null;
  loading: boolean;
  reviewProfile: CompanyReviewProfile | null;
  refetchReviews: VoidFunction;
}

export function CompanyPrivilegedReviewsContainer(props: Props) {
  const { companyId, error, loading, reviewProfile, refetchReviews } = props;

  return (
    <Stack direction="column" spacing={3}>
      <CreateCompanyReviewModal
        sx={{ mt: "1rem" }}
        companyId={companyId}
        onReviewSubmittedRefresh={refetchReviews}
      />
      <CompanyPrivilegedReviews
        error={error}
        loading={loading}
        reviewProfile={reviewProfile}
      />
    </Stack>
  );
}
